import React, { useEffect, useState } from 'react';
import { RichUtils, EditorState } from 'draft-js';
import { getSelectionInlineStyle, getSelectedBlock } from 'draftjs-utils';

import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';

type Props = {
  editorState?: EditorState;
  onChange?: Function;
};

const INLINE_STYLES = [
  { label: 'Bold', style: 'BOLD', icon: 'bold' },
  { label: 'Italic', style: 'ITALIC', icon: 'italic' },
  { label: 'Underline', style: 'UNDERLINE', icon: 'underline' },
];

const BLOCK_TYPES = [
  { label: 'UL', block: 'unordered-list-item', icon: 'list-ul' },
  { label: 'OL', block: 'ordered-list-item', icon: 'list-ol' },
];

const Toolbar = ({ editorState, onChange }: Props) => {
  const [currentStyles, setCurrentStyle] = useState(getSelectionInlineStyle(editorState));
  const [currentBlock, setCurrentBlock] = useState(getSelectedBlock(editorState));

  const toggleStyling = style => {
    const newState = RichUtils.toggleInlineStyle(editorState, style);
    if (newState) {
      onChange(newState);
    }
  };

  const toggleBlockType = block => {
    const newState = RichUtils.toggleBlockType(editorState, block);
    if (newState) {
      onChange(newState);
    }
  };

  useEffect(() => {
    if (editorState) {
      setCurrentStyle(getSelectionInlineStyle(editorState));
      setCurrentBlock(getSelectedBlock(editorState));
    }
  }, [editorState]);

  if (!editorState) return null;

  return (
    <WpButtonGroup spacing="sm">
      {INLINE_STYLES.map(type => (
        <WpButton
          size="xs"
          color="gray"
          variant={currentStyles[type.style] === true ? 'primary' : 'tertiary'}
          onMouseDown={e => {
            e.preventDefault();
            toggleStyling(type.style);
          }}
          key={`inline-${type.style}-toolbar-item`}
          square
        >
          <WpIcon name={type.icon} size="sm" />
        </WpButton>
      ))}
      {BLOCK_TYPES.map(type => (
        <WpButton
          size="xs"
          color="gray"
          variant={currentBlock.get('type') === type.block ? 'primary' : 'tertiary'}
          onMouseDown={e => {
            e.preventDefault();
            toggleBlockType(type.block);
          }}
          key={`block-${type.block}-toolbar-item`}
          square
        >
          <WpIcon name={type.icon} size="sm" />
        </WpButton>
      ))}
    </WpButtonGroup>
  );
};

export default Toolbar;
